/**
 * A card with its own information button.
 *
 * `explain` is required rather than optional, and that is the whole design.
 * When it was optional, nineteen panels across the server rendered tier shipped
 * without a button: each one looked finished, each one answered 200, and the
 * only way the gap was found was a static walk of the templates. A required
 * argument moves that from an audit to a compile error.
 *
 * Where a panel genuinely needs no explainer of its own, `explain="inherit"`
 * says so deliberately: the page-level button covers it. A refusal notice and
 * the placeholder roadmap are the two real cases, because on both the page
 * itself is the explanation.
 */
import type { ReactNode } from 'react'

import { ExplainButton } from './Explainer'

export function Panel({ title, explain, actions, children, tight, foot }: {
  title: ReactNode
  /** A section key whose explainer answers for this panel, or 'inherit'. */
  explain: string | 'inherit'
  actions?: ReactNode
  children: ReactNode
  tight?: boolean
  foot?: ReactNode
}) {
  return (
    <div className="card">
      <header className="card-head">
        {title}
        {explain !== 'inherit' && (
          <ExplainButton sectionKey={explain}
                         title={typeof title === 'string' ? title : undefined} />
        )}
        {actions && <><div className="grow" />{actions}</>}
      </header>
      <div className={`card-body${tight ? ' tight' : ''}`}>{children}</div>
      {foot && <div className="card-foot">{foot}</div>}
    </div>
  )
}

export function Cols({ children }: { children: ReactNode }) {
  return <div className="cols">{children}</div>
}
